import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiUrl } from "../../constants";

export const fetchPackageProgress = createAsyncThunk(
  "package/fetchProgress",
  async (package_id, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await fetch(
        `${apiUrl}/get_progress?package_id=${package_id}`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Fetching package progress failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const packageProgressSlice = createSlice({
  name: "packageProgress",
  initialState: {
    progress: null,
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
  },
  reducers: {
    clearPackageProgress: (state) => {
      state.progress = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackageProgress.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPackageProgress.fulfilled, (state, action) => {
        state.status = "success";
        state.progress = action.payload.progress;
      })
      .addCase(fetchPackageProgress.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
        state.progress = null;
      });
  },
});

export const { clearPackageProgress } = packageProgressSlice.actions;
export default packageProgressSlice.reducer;
